import moment from 'moment-timezone';

export function isExpired(validTo: Date) {
  return moment.utc().isAfter(moment.utc(validTo));
}
